import CIMSBadge from 'components/CIMSBadge'
import { CIMSBadgeProps } from 'components/CIMSBadge/types'
import { WorkflowConnection } from '../../../../../PayItemsModuleContext/types'

const WorkflowMenuItem: React.FC<WorkflowConnection & CIMSBadgeProps> = ({
  workflow: { label },
  count = 0,
}) => {
  if (count > 0) return <CIMSBadge count={count}>{label}</CIMSBadge>
  return <>{label}</>
}

export default WorkflowMenuItem
